(() => {
  const initialize = (attempt = 0) => {
    document.querySelectorAll('[data-ck-native-color-images]').forEach((dataElement) => {
      if (dataElement.dataset.ready) return;
      const root = dataElement.closest('[data-product-root]');
      if (!root) return;
      const data = JSON.parse(dataElement.textContent);
      const preserveHaloDefault = String(data.productId) === '9946344685844';
      const colorKey = (value) => String(value || '').toLowerCase().replace(/[\s-]/g, '').replace('グレイシャー', 'glacier').replace('バーガンディ', 'burgundy').replace('gentleblue', 'glacier').replace('cherrylush', 'burgundy');
      const matchesColor = (candidate, color) => preserveHaloDefault ? colorKey(candidate.color) === colorKey(color) : candidate.color === color;
      const managedFrost = String(data.productId) === '9946340589844';
      // Frost's first eight native secondary slides are Burgundy; later slides are other SKU heroes.
      const originalSecondaryCount = managedFrost && data.groups.length ? 8 : 10;
      const count = Math.max(originalSecondaryCount + 1, ...data.groups.map((group) => group.images.length));
      const main = root.querySelector('.splide--product');
      if (!main || !count || !window.Alpine?.mutateDom || main.querySelectorAll('.feature-media-item').length < 2) return;
      const optimizedLinkoo = main.hasAttribute('data-ck-gallery-loading');
      if (optimizedLinkoo && window.casekooLinkooGallery?.root !== root) return;
      dataElement.dataset.ready = 'true';
      if (preserveHaloDefault) main.dataset.ckHaloColorGallery = 'true';
      // Reuse native slide IDs, thumbnails, Alpine bindings, lazy loading and Splide.
      // Keep native layout and navigation, with only the selected group's image set.
      const rails = [
        [...main.querySelectorAll('.feature-media-item')],
        ...[...root.querySelectorAll('.splide[id^="slideshow-thumbnails-"], .splide[id^="slideshow-mobile-thumbnails-"]')].map((rail) =>
          [...rail.querySelectorAll('.product-thumbnail-list-item')])
      ];
      const attributes = ['src', 'srcset', 'alt', 'data-src', 'data-srcset', 'data-casekoo-gallery-lazy'];
      const parents = rails.map((rail) => rail[0].parentElement);
      // Retain the original last thumbnail node so native end-of-rail observers still work.
      const slots = rails.map((rail) => (preserveHaloDefault ? rail.slice(1) : [...rail.slice(1, count), rail.at(-1)]).map((node) => {
        const image = node.querySelector('img');
        const link = node.querySelector('a.media-thumbnail');
        return {
          node, image, link, mediaId: node.dataset.mediaId,
          original: image && Object.fromEntries(attributes.map((name) => [name, image.getAttribute(name)])),
          href: link?.getAttribute('href')
        };
      }));
      const originalGroup = { images: slots[0].slice(0, originalSecondaryCount).map(({ original }) => ({
        src: original['data-src'] || original.src, alt: original.alt || ''
      })) };
      const selectDesktopMedia = (selected) => {
        if (!optimizedLinkoo && !preserveHaloDefault && !managedFrost) return;
        rails[0].forEach((slide) => slide.classList.toggle('ck-color-media-selected', slide === selected));
        main.dataset.ckColorNavigation = 'true';
      };
      selectDesktopMedia(rails[0][0]);
      let active = false;
      let generation = 0;
      let limited = false;
      let pendingRails = false;
      // Native variant swaps identify displaced secondary media by changing its ID.
      // Keep their baseline without restoring old image URLs between color groups.
      const rememberNativeMedia = () => slots.flat().forEach((slot) => {
        if (!slot.image || slot.mediaId === slot.node.dataset.mediaId) return;
        slot.original = Object.fromEntries(attributes.map((name) => [name, slot.image.getAttribute(name)]));
        slot.href = slot.link?.getAttribute('href');
        slot.mediaId = slot.node.dataset.mediaId;
      });
      const refreshNativeGallery = (updateRails) => {
        const instances = [...root.querySelectorAll('.splide[id]')]
          .map((element) => window.slideshows?.[element.id]).filter(Boolean);
        const states = window.Splide?.STATES;
        const resetInstances = (preserveHaloDefault || optimizedLinkoo || managedFrost) && states ? instances.filter((instance) =>
          !instance.state.is([states.CREATED, states.DESTROYED]) &&
          instance.Components?.Move && instance.Components?.Controller
        ) : [];
        // Replacing slides during a native transition can suppress transitionend.
        // Cancel before changing the DOM; jump()/refresh() alone do not clear MOVING.
        resetInstances.forEach((instance) => {
          instance.Components.Move.cancel();
          instance.Components.Scroll?.cancel();
          instance.state.set(states.IDLE);
          instance.Components.Controller.setIndex(0);
        });
        updateRails();
        instances.forEach((instance) => {
          if ((!preserveHaloDefault && !optimizedLinkoo && !managedFrost) || !states || !instance.state.is([states.CREATED, states.DESTROYED])) {
            instance.refresh();
          }
        });
        // Refresh repositions at zero. Use native completion to update inert/media
        // listeners as well, without a second animated transition or synthetic events.
        resetInstances.forEach((instance) => instance.Components.Controller.go(0, true));
      };
      const limitGallery = (group) => {
        // Preserve the existing Alpine bindings while temporarily detaching extra media.
        refreshNativeGallery(() => window.Alpine.mutateDom(() => {
          rails.forEach((rail, index) => {
            const keep = [...rail.slice(0, group.images.length), rail.at(-1)];
            parents[index].replaceChildren(...keep);
          });
        }));
        limited = true;
        pendingRails = false;
      };
      const imageUrl = (source, width) => {
        const url = new URL(source, location.origin);
        url.searchParams.set('width', String(width));
        return url.href;
      };
      const loadThumbnails = () => {
        // Give native browser lazy loading the real thumbnail URL, as in theme 186 copy.
        // A custom observer may already have stopped watching these images after a color swap.
        root.querySelectorAll('.product-thumbnail-list-item img[data-src]').forEach((image) => {
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
          image.removeAttribute('data-casekoo-gallery-lazy');
        });
      };
      if (optimizedLinkoo || preserveHaloDefault || managedFrost) {
        // Read the current node ID: native variant swaps can change IDs, and
        // detached/reinserted thumbnails can retain their original bindings.
        const selectThumbnail = (event) => {
          if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
          const link = event.target.closest?.('a.media-thumbnail');
          const thumbnail = link?.closest('.product-thumbnail-list-item');
          if (!thumbnail || !root.contains(thumbnail)) return;
          event.preventDefault();
          const slides = [...main.querySelectorAll('.feature-media-item')];
          const index = slides.findIndex((slide) => slide.dataset.mediaId === thumbnail.dataset.mediaId);
          if (index < 0) return;
          event.stopImmediatePropagation();
          selectDesktopMedia(slides[index]);
          const product = window.Alpine.$data(root);
          product.currentMediaId = Number(thumbnail.dataset.mediaId);
          product.casekooMediaRevision = (product.casekooMediaRevision || 0) + 1;
          if (matchMedia('(max-width: 989px)').matches) {
            const instance = window.slideshows?.[main.id];
            const states = window.Splide?.STATES;
            if (instance?.Components?.Controller && states &&
                !instance.state.is([states.CREATED, states.DESTROYED])) {
              instance.Components.Move.cancel();
              instance.Components.Scroll?.cancel();
              instance.state.set(states.IDLE);
              instance.Components.Controller.go(index, true);
            }
          }
          if (optimizedLinkoo) window.casekooLinkooGallery.initial();
        };
        root.addEventListener('click', selectThumbnail, true);
        root.addEventListener('keydown', selectThumbnail, true);
      }
      const restore = () => {
        if (!active) return;
        slots.flat().forEach(({ image, link, original, href }) => {
          if (!image) return;
          const alreadyHydrated = !image.hasAttribute('data-src');
          for (const [name, value] of Object.entries(original)) {
            if (value === null) image.removeAttribute(name);
            else image.setAttribute(name, value);
          }
          // Restore the image, never reintroduce a placeholder for an already hydrated slot.
          if (alreadyHydrated && original['data-src']) {
            image.src = original['data-src'];
            if (original['data-srcset']) image.srcset = original['data-srcset'];
            image.removeAttribute('data-src');
            image.removeAttribute('data-srcset');
            image.removeAttribute('data-casekoo-gallery-lazy');
          }
          if (link && href) link.setAttribute('href', href);
        });
        active = false;
        delete root.dataset.ckColorMediaActive;
        if (limited || pendingRails) {
          refreshNativeGallery(() => window.Alpine.mutateDom(() => {
            rails.forEach((rail, index) => parents[index].replaceChildren(...rail));
          }));
          limited = false;
          pendingRails = false;
        }
        loadThumbnails();
      };
      const apply = (variant, productId) => {
        const color = variant?.options?.[data.colorPosition];
        const group = data.groups.find((candidate) => matchesColor(candidate, color));
        if (preserveHaloDefault) {
          // A Frost variant can have the same color and root as Halo. Fail closed.
          if (String(productId) !== String(data.productId) ||
              !['glacier', 'burgundy'].includes(colorKey(color)) || !group?.images?.length ||
              !rails.every((rail) => group.images.length < rail.length)) return;
          // On first activation snapshot after native handling; while active only
          // remember native ID swaps, never snapshot an injected group as a baseline.
          if (!active) slots.flat().forEach((slot) => {
            if (!slot.image) return;
            slot.original = Object.fromEntries(attributes.map((name) => [name, slot.image.getAttribute(name)]));
            slot.href = slot.link?.getAttribute('href');
            slot.mediaId = slot.node.dataset.mediaId;
          });
        }
        // Keep the existing Burgundy images as a native fallback, but hide later other-color SKU heroes.
        const frostNativeBurgundy = managedFrost && data.groups.length > 0 && color === 'Burgundy';
        if (managedFrost && ((!group?.images?.length && !frostNativeBurgundy) ||
            !rails.every((rail) => (group?.images?.length || originalGroup.images.length) < rail.length))) return;
        const selectedGroup = group || originalGroup;
        slots.forEach((rail, railIndex) => selectedGroup.images.forEach((source, index) => {
          const slot = index === selectedGroup.images.length - 1 ? rail.at(-1) : rail[index];
          const { image, link, original } = slot;
          if (!image || !source) return;
          const nativeSet = original['data-srcset'] || original.srcset || '';
          const widths = [...nativeSet.matchAll(/\s(\d+)w/g)].map((match) => Number(match[1]));
          const effectiveWidths = optimizedLinkoo
            ? (railIndex === 0 ? [350, 480, 720, 960, 1280, 1600] : [90, 150, 240, 360])
            : widths.length ? widths : [200, 350, 450, 750, 960, 1280, 1600];
          const sourceSet = [...new Set(effectiveWidths)]
            .map((width) => `${imageUrl(source.src, width)} ${width}w`).join(', ');
          const deferred = image.hasAttribute('data-src');
          const nativeSrc = original['data-src'] || original.src || '';
          const width = Number(new URL(nativeSrc, location.origin).searchParams.get('width')) || 1280;
          image.alt = source.alt || '';
          if (optimizedLinkoo && railIndex === 0) {
            window.casekooLinkooGallery.defer(image, imageUrl(source.src, 1280), sourceSet, source.alt);
          } else if (optimizedLinkoo) {
            image.srcset = sourceSet;
            image.src = imageUrl(source.src, 240);
            image.removeAttribute('data-src');
            image.removeAttribute('data-srcset');
            image.removeAttribute('data-casekoo-gallery-lazy');
          } else if (deferred) {
            image.dataset.src = imageUrl(source.src, width);
            image.dataset.srcset = sourceSet;
          } else {
            image.srcset = sourceSet;
            image.src = imageUrl(source.src, width);
            image.removeAttribute('data-src');
            image.removeAttribute('data-srcset');
          }
          if (link) link.href = imageUrl(source.src, 2000);
        }));
        active = true;
        root.dataset.ckColorMediaActive = color;
        limitGallery(selectedGroup);
        selectDesktopMedia(rails[0][0]);
        if (preserveHaloDefault) loadThumbnails();
        if (optimizedLinkoo) window.casekooLinkooGallery.changed();
      };
      document.addEventListener('theme:variant:change', (event) => {
        if (event.detail?.productRootEl !== root) return;
        if (optimizedLinkoo) window.casekooLinkooGallery.beforeChange();
        if ((preserveHaloDefault || optimizedLinkoo) && active) {
          rememberNativeMedia();
          // Native handlers must see detached media for their ID swaps. Restore
          // nodes only: no old URL writes, thumbnail hydration or intermediate refresh.
          if (limited) {
            window.Alpine.mutateDom(() => {
              rails.forEach((rail, index) => parents[index].replaceChildren(...rail));
            });
            limited = false;
            pendingRails = true;
          }
        } else if (!preserveHaloDefault && !optimizedLinkoo) restore();
        const token = ++generation;
        requestAnimationFrame(() => {
          if (token !== generation) return;
          selectDesktopMedia(rails[0][0]);
          if (preserveHaloDefault) {
            rememberNativeMedia();
            const color = event.detail.variant?.options?.[data.colorPosition];
            const group = data.groups.find((candidate) => matchesColor(candidate, color));
            if (String(event.detail.product?.id) !== String(data.productId) ||
                !['glacier', 'burgundy'].includes(colorKey(color)) || !group?.images?.length ||
                !rails.every((rail) => group.images.length < rail.length)) {
              restore();
              return;
            }
          }
          if (managedFrost && String(event.detail.product?.id) !== String(data.productId)) return;
          apply(event.detail.variant, event.detail.product?.id);
        });
      }, true);
      const currentProduct = preserveHaloDefault ? window.Alpine.$data?.(root) : null;
      apply(currentProduct?.currentVariant || data.variant, currentProduct?.product?.id || data.productId);
      loadThumbnails();
    });
    if (attempt < 100 && document.querySelector('[data-ck-native-color-images]:not([data-ready])')) {
      setTimeout(() => initialize(attempt + 1), 100);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  window.addEventListener('load', () => initialize(), { once: true });
  document.addEventListener('shopify:section:load', () => initialize());
})();

